var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 576 384",
    style: {
      enableBackground: "new 0 0 576 384"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#030344;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M549.7,60.1c-6.3-23.7-24.8-42.3-48.3-48.6C458.8,0,288,0,288,0S117.2,0,74.6,11.5c-23.5,6.3-42,24.9-48.3,48.6 C14.9,103,14.9,192.4,14.9,192.4s0,89.4,11.4,132.3c6.3,23.7,24.8,41.5,48.3,47.8C117.2,384,288,384,288,384s170.8,0,213.4-11.5 c23.5-6.3,42-24.2,48.3-47.8c11.4-42.9,11.4-132.3,11.4-132.3S561.1,103,549.7,60.1L549.7,60.1z M232.2,273.6V111.2l142.7,81.2 L232.2,273.6L232.2,273.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.84e3e6ade2c46af4cfd16fefd3df5288.svg";
export { ForwardRef as ReactComponent };